import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ColorPickerCardOptions } from './color-picker-card.model';

export interface ColorPickerCardComponentData {
  color: string;
  options?: ColorPickerCardOptions;
  colorChanged: (color: string) => {};
  colorSelected: (color: string) => {};
}

@Component({
  selector: 'gio-color-picker-card',
  templateUrl: './color-picker-card.component.html',
  styleUrls: ['./color-picker-card.component.scss']
})
export class ColorPickerCardComponent implements OnInit {

  @Input()
  color: string;

  @Input()
  options: ColorPickerCardOptions;

  @Output()
  colorChanged = new EventEmitter();

  @Output()
  colorSelected = new EventEmitter();

  _color: string;


  constructor(
    private modal: MatDialogRef<ColorPickerCardComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: ColorPickerCardComponentData
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.color = this.data.color;
      this.options = this.data.options;
    }

    if (!this.options) {
      this.options = {
        type: 'chrome'
      }
    }

    if (!this.options.type){
      this.options.type = 'chrome';
    }

  }

  onColorChanged(color: string) {
    if (this.data && this.data.colorChanged) {
      this.data.colorChanged(color);
      return;
    }
    this.colorChanged.emit(color);
    this._color = color;
  }

  removeColor() {
    this._color = '';
    this.save();
  }

  save() {
    //wait for color changed debounce time;
    setTimeout(() => {
      if (this.data) {
        if (this.data.colorSelected){
          this.data.colorSelected(this._color);
        } else {
          this.modal.close(this._color);
        }
        return;
      }
      this.colorSelected.emit(this._color);

    }, 30);
  }

}
